import axios from "axios";
import React, { useRef } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import fundo from "../../../../styles/fundo.svg";
import Swal from "sweetalert2";
import './style.css';

const FormContainer = styled.form`
  width: auto;
  background-color: #f4f4f5;
  display: flex; 
  align-items: flex-start;
  flex-direction: column;
  box-shadow: 0px 0px 2px #ccc;
  padding: 10px;
`;

const Div = styled.div`
  width:95%;
  background-color:#f4f4f5;
  display: flex; 
  padding: 10px 10px;
  align-items: flex-end;
  gap: 20px 0px;
  flex-direction: row;
 
`;


const TextAreaContainer = styled.div`
  width: auto;
  display: flex;
  flex-direction: column;
  
`;

const InputTitle = styled.input`
  width: 480px;
  height: 40px;
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 0px 10px;
  background-color: #f4f4f5;
  color:#3a3f42;
  font-size: 18px;
`;

const Label = styled.label`
  color: #3a3f42;
  font-weight: bold;
  font-family: 'Open Sans', sans-serif;
  font-size: 20px;
  margin: 0px 5px;

  @media (max-width: 500px) {
    font-size: 16px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end; 
  padding-left: 1px;
  flex-direction: column;

  @media (max-width: 500px) {
    justify-content: center; 
  }
`;

const Button = styled.button`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 10px ;
  cursor: pointer;
  border: none;
  background-image: url(${fundo});
  color: #fff;
  font-size: bold;
  font-size: 20px;
  gap: 5px;
  margin-top: 10px;
  border: 1px solid #ccc;
  border-radius: 10px;


`;



const Form = ({ urlApi, modalNovaColuna, fetchColunas, verQuadro }) => {
  const ref = useRef();

  //------------------------------------------------------------------------------///
  //Token da api
  const token = localStorage.getItem('token');
  const id = localStorage.getItem('id');


  //-----------------------------CONFIRMA A CRIAÇÃO DA LISTA ------------------------------//
  const showPopUp = () => {
    return new Promise((resolve) => {
      Swal.fire({
        title: "Deseja confirmar?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        customClass: {
          container: 'custom-swal-container', // Estiliza o container principal
          title: 'custom-swal-title', // Estiliza o título
          confirmButton: 'custom-swal-confirm-button', // Estiliza o botão de confirmação
          cancelButton: 'custom-swal-cancel-button', // Estiliza o botão de cancelamento
          popup: 'custom-swal-popup', // Estiliza o popup
          icon: 'custom-swal-icon' // Estiliza o ícone
        },
      }).then((result) => {
        resolve(result.value);
      });
    });
  };



  //---------------------------------------FUNÇÃO QUE INSERE A LISTA NO BANCO----------------------------------------//


  const handleSubmit = async (e) => {
    e.preventDefault();
    const user = ref.current;

    const descricao_listaValue = user.descricao_lista.value;

    if (!descricao_listaValue) {
      return toast.warn("Preencha todos os campos!");
    }


    if (descricao_listaValue.length > 50) {
      toast.warn("O nome da lista não pode ter mais que 50 caracteres.");
      return;
    }

    const userConfirmed = await showPopUp(); // Aguarde a resolução da Promise

    if (!userConfirmed) {
      return;
    }
    try {
      const requestData1 = {
        id_criador: id,
        id_quadro: verQuadro.ID_QUADRO,
        descricao_lista: descricao_listaValue,
      };
      await axios.post(`${urlApi}painel-monitoramento/nova-lista`, requestData1, { headers: { Authorization: `Bearer ${token}` } });

      setTimeout(function () {
        modalNovaColuna()
      }, 1000);

      toast.success("Lista criada com sucesso!")
      fetchColunas();
    } catch (error) {
      if (error.response) {
        const errorMessage = error.response.data.error;
        toast.error(errorMessage);
      }
    }
  };



  return (
    <div >
      <FormContainer ref={ref} onSubmit={handleSubmit}>

        <Div>

          <TextAreaContainer>
            <Label>Escolha um nome para lista:</Label>
            <InputTitle id="descricao_lista" name="msg" placeholder="Digite aqui..."></InputTitle>
          </TextAreaContainer>

        </Div>

        <Div>
          <Button title="Salvar" type="submit" >
            Criar
          </Button>
        </Div>
      </FormContainer>
      <style jsx global>{`
      .swal2-container.custom-swal-container {
        z-index: 9999; 
      }
    `}</style>
    </div>

  );
};

export default Form;


